import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { MapContainer } from "react-leaflet";
import MarkerComponent from "./Marker";
import IconMarker from "./Icon";
import { useTranslate } from "../../hooks/LanguageProvider";
import { getAddressFromCoordinates } from "../../utilities/functions"; // Importer la fonction
import BaseMapLayerControl from "./BaseMapLayerControl";
import { useBaseMapPreference } from "../../hooks/useBaseMapPreference";

interface MapModalProps {
  show: boolean;
  onClose: () => void;
  lat: number;
  lng: number;
}
const backendUrl = process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";

const MapModal: React.FC<MapModalProps> = ({
  show,
  onClose,
  lat,
  lng,
}) => {
  const position = [lat, lng] as [number, number];
  const { translate } = useTranslate();
  const [address, setAddress] = useState<string>(""); // État pour stocker l'adresse

  const [baseMap, setBaseMap] = useBaseMapPreference("modal");

  useEffect(() => {
    // Appeler la fonction getAddressFromCoordinates lorsque les coordonnées changent
    const fetchAddress = async () => {
      try {
        const address = await getAddressFromCoordinates(lat, lng);
        setAddress(address);
      } catch (error) {
        console.error("Failed to fetch address:", error);
        setAddress("Address not found");
      }
    };

    fetchAddress();
  }, [lat, lng]); // Exécuter l'effet à chaque changement de lat ou lng

  // Example custom icon creation
  const customIcon = IconMarker(90, "asset/images/mapicon/car.svg", () => {
    // onClick functionality
  });

  return (
    <Modal show={show} onHide={onClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title style={{alignContent:"center"}}>{translate("Vehicle Position")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <MapContainer
          center={position}
          zoom={13}
          style={{ height: "500px", width: "100%" }}
        >
          <BaseMapLayerControl
            value={baseMap}
            onChange={setBaseMap}
            tokenUrl={`${backendUrl}/api/mapkit/token`}
          />
          {/* Use MarkerComponent with custom icon */}
          <MarkerComponent
            position={position}
            text={`position: ${lat},${lng}<br />adresse: ${address}`}
            icon={customIcon}
          />
        </MapContainer>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          {translate("Close")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MapModal;
